import { render, staticRenderFns } from "./FormCertificate.vue?vue&type=template&id=5278f39e&scoped=true"
import script from "./FormCertificate.vue?vue&type=script&lang=js"
export * from "./FormCertificate.vue?vue&type=script&lang=js"
import style0 from "./FormCertificate.vue?vue&type=style&index=0&id=5278f39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278f39e",
  null
  
)

export default component.exports